import Image from "next/image";
import { RenderImage, RenderImageProps } from "./renderImage";

const DEFAULT_WIDTH = 1920;
const DEFAULT_HEIGHT = 1080;
const DEFAULT_SIZES = "100vw";

export const createNextRenderImage =
  (defaults: Partial<RenderImageProps> = {}): RenderImage =>
  ({ src, alt, width, height, className, sizes, loading, priority }) => {
    const isPriority = priority ?? defaults.priority ?? false;

    return (
      <Image
        src={src}
        alt={alt}
        width={width ?? defaults.width ?? DEFAULT_WIDTH}
        height={height ?? defaults.height ?? DEFAULT_HEIGHT}
        className={className}
        sizes={sizes ?? defaults.sizes ?? DEFAULT_SIZES}
        loading={
          isPriority ? undefined : (loading ?? defaults.loading ?? "lazy")
        }
        priority={isPriority}
      />
    );
  };

export const nextRenderImage: RenderImage = createNextRenderImage();
